import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { yonetim } from './api';
import { oturumKaydet, oturumTemizle, girisYapildiMi, adSoyad } from './auth';

import Pano from './pages/Pano';
import Kuyumcular from './pages/Kuyumcular';
import KuyumcuDetay from './pages/KuyumcuDetay';
import Kampanyalar from './pages/Kampanyalar';
import Reklamlar from './pages/Reklamlar';
import Parametreler from './pages/Parametreler';
import Raporlar from './pages/Raporlar';

function Login({ onGiris }) {
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  async function gonder(e) {
    e.preventDefault();
    setHata('');
    setYukleniyor(true);
    try {
      const yanit = await yonetim.giris(kullaniciAdi.trim(), sifre);
      oturumKaydet(yanit);
      onGiris();
    } catch (err) {
      setHata(err.durum === 400 || err.durum === 401
        ? 'Kullanıcı adı veya şifre hatalı.'
        : (err.message || 'Giriş başarısız.'));
      setYukleniyor(false);
    }
  }

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={gonder}>
        <h2>Altın<span style={{ color: '#d4af37' }}>Teklifim</span></h2>
        <p className="login-alt">Yönetim Paneli</p>
        {hata && <p className="login-error">{hata}</p>}
        <input
          placeholder="Kullanıcı adı"
          value={kullaniciAdi}
          onChange={(e) => setKullaniciAdi(e.target.value)}
          autoFocus
          required
        />
        <input
          type="password"
          placeholder="Şifre"
          value={sifre}
          onChange={(e) => setSifre(e.target.value)}
          required
        />
        <button type="submit" disabled={yukleniyor}>
          {yukleniyor ? 'Giriş yapılıyor…' : 'Giriş Yap'}
        </button>
      </form>
    </div>
  );
}

function Sidebar({ onCikis, panoSayilari, acik, onKapat }) {
  const navigate = useNavigate();
  const location = useLocation();

  const bekleyenToplam =
    (panoSayilari?.bekleyenKuyumcu || 0) +
    (panoSayilari?.bekleyenKampanya || 0) +
    (panoSayilari?.bekleyenReklam || 0);

  const menu = [
    { path: '/', label: 'Pano', icon: '📊' },
    { path: '/kuyumcular', label: 'Kuyumcu Onayları', icon: '🏬', rozet: panoSayilari?.bekleyenKuyumcu },
    { path: '/kampanyalar', label: 'Kampanya Onayları', icon: '📣', rozet: panoSayilari?.bekleyenKampanya },
    { path: '/reklamlar', label: 'Reklam Onayları', icon: '🖼', rozet: panoSayilari?.bekleyenReklam },
    { path: '/parametreler', label: 'Parametreler', icon: '⚙️' },
    { path: '/raporlar', label: 'Raporlar', icon: '📈' },
  ];

  const aktifMi = (path) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  function git(path) {
    navigate(path);
    onKapat && onKapat();
  }

  return (
    <div className={`sidebar${acik ? ' acik' : ''}`}>
      <div className="sidebar-logo">Altın<span>Teklifim</span></div>
      <div className="sidebar-user">
        {adSoyad()}
        {bekleyenToplam > 0 && ` · ${bekleyenToplam} bekleyen`}
      </div>
      <ul className="sidebar-menu">
        {menu.map((item) => (
          <li
            key={item.path}
            className={aktifMi(item.path) ? 'active' : ''}
            onClick={() => git(item.path)}
          >
            <span>{item.icon}</span> {item.label}
            {item.rozet > 0 && <span className="badge">{item.rozet}</span>}
          </li>
        ))}
      </ul>
      <div className="sidebar-logout">
        <button onClick={onCikis}>Çıkış Yap</button>
      </div>
    </div>
  );
}

function Layout({ children, onCikis, panoSayilari }) {
  const [menuAcik, setMenuAcik] = useState(false);

  return (
    <div className="layout">
      <div className="topbar">
        <button className="hamburger" onClick={() => setMenuAcik(true)} aria-label="Menü">☰</button>
        <div className="topbar-logo">Altın<span>Teklifim</span></div>
      </div>
      {menuAcik && <div className="sidebar-overlay" onClick={() => setMenuAcik(false)} />}
      <Sidebar
        onCikis={onCikis}
        panoSayilari={panoSayilari}
        acik={menuAcik}
        onKapat={() => setMenuAcik(false)}
      />
      <div className="main-content">{children}</div>
    </div>
  );
}

export default function App() {
  const [girisli, setGirisli] = useState(girisYapildiMi());
  const [panoSayilari, setPanoSayilari] = useState(null);

  const panoyuYenile = useCallback(() => {
    if (!girisYapildiMi()) return;
    yonetim.pano().then(setPanoSayilari).catch(() => {});
  }, []);

  useEffect(() => {
    if (girisli) panoyuYenile();
  }, [girisli, panoyuYenile]);

  function cikis() {
    oturumTemizle();
    setPanoSayilari(null);
    setGirisli(false);
  }

  if (!girisli) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Login onGiris={() => setGirisli(true)} />} />
        </Routes>
      </BrowserRouter>
    );
  }

  const sar = (icerik) => (
    <Layout onCikis={cikis} panoSayilari={panoSayilari}>
      {icerik}
    </Layout>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="/" element={sar(<Pano />)} />
        <Route path="/kuyumcular" element={sar(<Kuyumcular onDegisim={panoyuYenile} />)} />
        <Route path="/kuyumcular/:id" element={sar(<KuyumcuDetay onDegisim={panoyuYenile} />)} />
        <Route path="/kampanyalar" element={sar(<Kampanyalar onDegisim={panoyuYenile} />)} />
        <Route path="/reklamlar" element={sar(<Reklamlar onDegisim={panoyuYenile} />)} />
        <Route path="/parametreler" element={sar(<Parametreler />)} />
        <Route path="/raporlar" element={sar(<Raporlar />)} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
